import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop"; 
import Navbar from "./Components/Navbar";
import Display from "./Components/Display";
import PrincipalDesk from "./Components/PrincpalDesk";
import PresidentMessage from "./Components/President";
import Certification from "./Components/Certification";
import Shaping from "./Components/Shaping";
import KeyInformation from "./Components/KeyInformation";
import Campus from "./Components/Campus";
import Glance from "./Components/Glance";
import Footer from "./Components/Footer";
import Facilities from "./Sections/Facilities";
import Gallery from "./Sections/Gallery";
import Enroll from "./Sections/Enroll";

// Subsections inside Facilities
import ChemistryLab from "./SubSections/Chemistry";
import BiologyLab from "./SubSections/Biology";
import ComputerLab from "./SubSections/Computer";
import PhysicsLab from "./SubSections/Physics";
import MusicRoom from "./SubSections/Music";
import Sports from "./SubSections/Sports";
import Library from "./SubSections/Library";
import SmartClass from "./SubSections/Smart";

// Campus & Transport info subsections
import Transport from "./InformationData/Transport";
import Campusinfo from "./InformationData/Campusinfo";
import Books from "./InformationData/Books";
import Faculty from "./InformationData/Faculty";
import AcademicCalendar from "./InformationData/AcademicCalendar";
import Uniform from "./InformationData/Uniform";

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Display />
              <PrincipalDesk />
              <PresidentMessage />
              <Shaping />
              <KeyInformation />
              <Certification />
              <Campus />
              <Glance />
            </>
          }
        />

        {/* Facilities Section (Primary) */}
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/facilities/chemistry-lab" element={<ChemistryLab />} />
        <Route path="/facilities/biology-lab" element={<BiologyLab />} />
        <Route path="/facilities/computer-lab" element={<ComputerLab />} />
        <Route path="/facilities/physics-lab" element={<PhysicsLab />} />
        <Route path="/facilities/music-room" element={<MusicRoom />} />
        <Route path="/facilities/sports" element={<Sports />} />
        <Route path="/facilities/library" element={<Library />} />
        <Route path="/facilities/smart-class" element={<SmartClass />} />
        <Route path="/facilities/transport" element={<Transport />} />
        <Route path="/facilities/campus-info" element={<Campusinfo />} />

        {/* Academics Aliases (Ensures backward-compatibility) */}
        <Route path="/academics" element={<Facilities />} />
        <Route path="/academics/chemistry-lab" element={<ChemistryLab />} />
        <Route path="/academics/biology-lab" element={<BiologyLab />} />
        <Route path="/academics/computer-lab" element={<ComputerLab />} />
        <Route path="/academics/physics-lab" element={<PhysicsLab />} />
        <Route path="/academics/music-room" element={<MusicRoom />} />
        <Route path="/academics/sports" element={<Sports />} />
        <Route path="/academics/library" element={<Library />} />
        <Route path="/academics/smart-class" element={<SmartClass />} />
        <Route path="/academics/transport" element={<Transport />} />
        <Route path="/academics/campus-info" element={<Campusinfo />} />

        {/* Information Section Redirect / Fallbacks */}
        <Route path="/information" element={<Navigate to="/facilities" replace />} />
        <Route path="/information/transport" element={<Transport />} />
        <Route path="/information/campus-info" element={<Campusinfo />} />
        <Route path="/information/books" element={<Books />} />
        <Route path="/information/faculty" element={<Faculty />} />
        <Route path="/information/calendar" element={<AcademicCalendar />} />
        <Route path="/information/uniform" element={<Uniform />} />

        {/* Other Sections */}
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/enroll" element={<Enroll />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
